import React from 'react';
import './style.scss';
import { Driver as DriverIcon, DefaultIcon, GradientIcon } from '../../../atoms/icons/index';

interface Props {
    title: string;
    name: string;
    icon?: React.ReactElement<DefaultIcon> | React.ReactElement<GradientIcon> | undefined;
    day?: string;
    id: string | number;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const Driver: React.FC<Props> = (props) => {
  const {
    title, day, id, name, onClick,
    icon = <DriverIcon width={24} />,
  } = props;
  return (
    <button
      type="button"
      id={id.toString()}
      className="card-container"
      onClick={onClick}
    >
      <div className="left-container">
        <div className="title">{title}</div>
        <div className="driver">
          <div className={icon ? 'me-2' : 'd-none'} style={{ marginTop: '-2px' }}>{icon}</div>
          <div className="fz-14">{name}</div>
        </div>
      </div>
      <div className={day ? 'day-container' : 'd-none'}>{day}</div>
    </button>
  );
};

export default Driver;
